import React from 'react';
import Axios from 'axios';
import { Card, CardHeader, CardBody, CardFooter, Collapse, Tooltip } from 'reactstrap';
import moment from 'moment';

const cstTableHeaders = ['Rg', 'Joueur', 'TRS', 'PJ', 'IPS', 'FP', '% VIC', 'DIFF', 'ERO', 'EC', 'TVP', 'Équipe'];

const SI_ID = 0;
const SI_STD = 1;
const SI_CMT = 2;
const SI_ELT = 3;
const SI_SAV = 4;


class RateSysForm extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			season: {name: ''},
			respondents: [],
			rateSysPlayersAll: [],
			rateSysPlayers: [],
			committeeList: [],
			elTrophyList: [],
			divisionText: "",

			onlyPlayersFromList: true,
			playersByDivision: true,
			selectedRespondentIdx: -1,
			respondentTel: "",
			selectedPlayerIdx: -1,
			selectedCommitteeIdx: [-1, -1, -1, -1, -1],
			selectedELTrophy: -1,

			sectionsIdx: [1, 2, 0, 0, 3]
		};
	
		this.dispOneCommittee = this.dispOneCommittee.bind(this);
		this.handleRespondentChange = this.handleRespondentChange.bind(this);
		this.handleRespondentTelChange = this.handleRespondentTelChange.bind(this);
		this.handleCommitteeChange = this.handleCommitteeChange.bind(this);
		this.handleELTRophyChange = this.handleELTRophyChange.bind(this);

		this.createTableHdrRow = this.createTableHdrRow.bind(this);
		this.dispPlayersTableRow = this.dispPlayersTableRow.bind(this);
		this.handleSingleClick = this.handleSingleClick.bind(this);
		this.handleSubmitFormClick = this.handleSubmitFormClick.bind(this);
}

	componentDidMount() {
		this.loadData();
	}

	loadData() {
    var _this = this;
    var seasonId = this.props.match.params.seasonid;

    Axios.get('/api/seasons/' + seasonId).then(function (responseSeason) {
    Axios.get('/api/ratesys/getRateSys/global/' + seasonId).then(function (responseRateSys) {

    	var rateSys = responseRateSys.data;
    	var respondents = [];
    	var players = [];
			var rateSysPlayers = [];
			var committeeList = [];
			var elTrophyList = [];

    	var onlyPlayersFromList = true;
    	var playersByDivision = true;

    	var sectionsIdx = [1, 2, 3, 4, 5];

    	if (rateSys !== "") {

				onlyPlayersFromList = rateSys.onlyPlayersFromList;
				playersByDivision = rateSys.playersByDivision;

				var sectIdx = 0;
				sectionsIdx.forEach((si, siIdx, sectionsIdx) => {
					if (((siIdx === SI_CMT) && (!rateSys.committeeVotes)) ||
					    ((siIdx === SI_ELT) && (!rateSys.elTrophyVotes)) ) {
						sectionsIdx[siIdx] = 0;
					} else {
						sectIdx++;
						sectionsIdx[siIdx] = sectIdx;
					}
				});

	    	// Create respondents table (personne sondées)
	    	players = rateSys.players;
				players.forEach(p => {
					if ((p.team !== "Substituts") && !(playersByDivision && p.teamDiv === '')) {
						respondents.push({
							_id: p._id,
							fn: p.fn,
							ratingStr: p.ratingStr,
							team: p.team,
							teamDiv: p.teamDiv
						});
					}
				});

				respondents = respondents.sort((a, b) => (a.fn.localeCompare(b.fn)));

				if (!playersByDivision) {
					rateSysPlayers = players;
					committeeList = respondents;
					elTrophyList = respondents;
				}

			}

			rateSysPlayers = _this.defaultSortPlayer(rateSysPlayers);

			_this.setState({
				season: responseSeason.data.season,
				respondents: respondents,
				rateSysPlayersAll: players,
				rateSysPlayers: rateSysPlayers,
				committeeList: committeeList,
				elTrophyList: elTrophyList,
				onlyPlayersFromList: onlyPlayersFromList,
				playersByDivision: playersByDivision,
				sectionsIdx: sectionsIdx
			});

		});
		});
	}

	loadPlayersAndCommittee(selectedRespondentIdx) {

		if (selectedRespondentIdx === -1) {
			this.setState({
				rateSysPlayers: [],
				committeeList: [],
				elTrophyList: [],
				selectedPlayerIdx: -1,
				selectedCommitteeIdx: [-1, -1, -1, -1, -1],
				selectedELTrophy: -1,
				divisionText: ""
			});

			return;
		}

		var rateSysPlayers = this.state.rateSysPlayersAll;
		var committeeList = this.state.respondents;
		var elTrophyList = this.state.respondents;
		var respondentId = this.state.respondents[selectedRespondentIdx]._id;
		var respondentTeam = this.state.respondents[selectedRespondentIdx].team;
		var respondentTeamDiv = this.state.respondents[selectedRespondentIdx].teamDiv;
		var divisionText = "";

		// Committee members must not be from same team as respondent
		committeeList = committeeList.filter(r => (r.team !== respondentTeam));
		elTrophyList = elTrophyList.filter(r => (r._id !== respondentId));

		if (this.state.playersByDivision) {
			rateSysPlayers = rateSysPlayers.filter(p => (p.teamDiv === respondentTeamDiv));

			// Committee members must not be from same team as respondent
			committeeList = committeeList.filter(r => (r.teamDiv === respondentTeamDiv));
			elTrophyList = elTrophyList.filter(r => (r.teamDiv === respondentTeamDiv));

			divisionText = respondentTeamDiv;
		}

		rateSysPlayers = this.defaultSortPlayer(rateSysPlayers);

		this.setState({
			rateSysPlayers: rateSysPlayers,
			committeeList: committeeList,
			elTrophyList: elTrophyList,
			selectedPlayerIdx: -1,
			selectedCommitteeIdx: [-1, -1, -1, -1, -1],
			selectedELTrophy: -1,
			divisionText: divisionText
		});
	}

	resetForm() {
		var _this = this;
		var rateSysPlayers = this.state.rateSysPlayers;
		rateSysPlayers = this.defaultSortPlayer(rateSysPlayers);

		this.setState({
			rateSysPlayers: rateSysPlayers,
			selectedRespondentIdx: -1,
			respondentTel: "",
			selectedPlayerIdx: -1,
			selectedCommitteeIdx: [-1, -1, -1, -1, -1],
			selectedELTrophy: -1
		});
	} 

	defaultSortPlayer(rateSysPlayers) {
		var _this = this;

		// Sort by rating and names
		// SAME AS IN RATESYSCONTROLLER 
		rateSysPlayers = rateSysPlayers.sort((a, b) => {
			var compRatings = 0;
			var ratingA = a.ratingStr.split('-')[0];
			var ratingB = b.ratingStr.split('-')[0];

    	if(_this.isNumeric(ratingA) && _this.isNumeric(ratingB)) {
				compRatings = parseInt(ratingA, 10) - parseInt(ratingB, 10);
    	} else {
    		console.log('is NOT numeric')
				compRatings = ratingA.localeCompare(ratingA);
			}

			if (compRatings !== 0) {
				return compRatings;
			} else {
				return b.stats.ips - a.stats.ips;
			}
		});

		return rateSysPlayers;
	}

 	render() {
		//console.log('RateSysForm: render');
		//console.log(this.state)

		return (
			<div className="animated fadeIn row-margin-bottom-100">

				<div className="row row-margin-bottom-20">
				<div className="col-12">
					<h4>{this.state.season.name}</h4>
					<h5>FORMULAIRE DE COTATION</h5>
				</div>
				</div>
				<hr className="hrThick"/>

				{/* Note explicative Divisions */}
				{this.state.playersByDivision ?
				<div className="row">
				<div className="col-12">
					<h6>NOTE SUR LES DIVISIONS</h6>
					<p>
						Votre ligue comporte des divisions et vos choix sont limités aux joueurs de votre division.<br/>Choisissez votre nom 
						dans la liste à l'étape 1 pour afficher la table de joueurs liée à votre division.
					</p>
				</div>
				</div>
				: null}

				<div className="row row-margin-bottom-50">
				<div className="col-xl-8 col-12">
				{this.dispIdentification()}
				{this.dispRankings()}
				</div>

				<div className="col-xl-4 col-12">
				{this.dispCommittee()}

				{/* CONDITIONNAL AU PARAMETRE DE SAISON "EL_TROPHY" */}
				{this.dispELTrophy()}
				
				{this.dispValidateAndSave()}
				</div>
				</div>

			</div>
		);
	}

	// Step 1 - IDENTIFICATION
	dispIdentification() {

		return(
			<div className="row rateSysSectionsMargins">
			<div className="col-12">
      <Card className="rateSysCard">
       	<CardHeader className="rateSysCardHeader">
					<h5><span className="fa fa-user"></span>&nbsp;&nbsp;ÉTAPE {this.state.sectionsIdx[SI_ID]} - Identification de la personne sondée</h5>
					<p>
						Choisir votre nom dans la liste de joueurs et entrer ensuite votre numéro de téléphone afin
						de valider votre identité et nous permettre de communiquer avec vous au besoin.
					</p>
        </CardHeader>
        <CardBody>

					{/*<span className="text-uppercase font-weight-bold">Identification</span>*/}
					<div className="row row-margin-bottom-10">
						{this.displayRespondentSelector()}
					</div>

			   	<div className="row">
			    <div className="col-md-8 col-12 form-group">
						<span>Téléphone</span>
						<input type="tel" className="form-control" name="tel" id="tel" autoComplete="tel" required
							value={this.state.respondentTel || ''} onChange={this.handleRespondentTelChange} />
					</div>
					</div>

					{(this.state.playersByDivision) ? 
			   	<div className="row">
			    <div className="col-md-8 col-12">
						<span>Division: {this.state.divisionText}</span>
					</div>
					</div>
					: null} 

	      </CardBody>
			</Card>
			</div>
			</div>
		)
	}

	// Step 2 - CLASSEMENT DES JOUEURS
	dispRankings() {
		return(
			<div className="row rateSysSectionsMargins">
			<div className="col-12">

	      <Card className="rateSysCard">
	       	<CardHeader className="rateSysCardHeader">
						<div className="row">
		        <div className="col-sm-10 col-12">
						<h5><span className="fa fa-table"></span>&nbsp;&nbsp;ÉTAPE {this.state.sectionsIdx[SI_STD]} - Classement des joueurs</h5>
						<p className="row-margin-bottom-10">
							Classer les joueurs dans la table en ordre de force selon votre point de vue. <br className="not-on-mobile"/>
							Les joueurs sont présentés initialement par TRS et ensuite par IPS décroissant. <br className="not-on-mobile" />
							Utiliser les boutons-flèche <i className="fa fa-arrow-up"></i> <i className="fa fa-arrow-down"></i> pour classer 
							les joueurs du plus fort (rang 1) au plus faible (rang {this.state.rateSysPlayers.length}).
						</p>
		        </div>

		        {/* NOT ON MOBILE */}
		        <div className="col-sm-2 col-12 align-right mt-auto">
		  				<button className="btn btn-primary btn-sm rateSysFormBtnUp" 
		  					onClick={this.handleArrowClick.bind(this, -1)} > 
		  					<i className="fa fa-arrow-up"></i>
							</button>
		  				<button className="btn btn-primary btn-sm rateSysFormBtnDown" 
		  					onClick={this.handleArrowClick.bind(this, 1)} > 
		  					<i className="fa fa-arrow-down"></i>
							</button>
		        </div>
		  	    </div>

	        </CardHeader>
	        <CardBody>
						{this.dispPlayersTable()}
		      </CardBody>
				</Card>
			</div>
			</div>
		)
	}

	// Step 3 - COMITÉ DE COTATION
	dispCommittee() {
		if (this.state.sectionsIdx[2] === 0) {
			return;
		}

		return(
			<div className="row rateSysSectionsMargins">
			<div className="col-12">

      <Card className="rateSysCard">
       	<CardHeader className="rateSysCardHeader">
					<h5><span className="fa fa-users"></span>&nbsp;&nbsp;ÉTAPE {this.state.sectionsIdx[SI_CMT]} - Comité de Cotation</h5>
					<p>
						Choisir 5 joueurs, qui ne font pas partie de votre équipe, à qui vous faites confiance pour faire partie du comité de cotation.
					</p>
        </CardHeader>
        <CardBody>
					{this.state.selectedCommitteeIdx.map(this.dispOneCommittee)}
		      </CardBody>
				</Card>
			</div>
			</div>
		)
	}

	// Step 4 - EL Trophy
	dispELTrophy() {
		if (this.state.sectionsIdx[3] === 0) {
			return;
		}

		return(
			<div className="row rateSysSectionsMargins">
			<div className="col-12">

      <Card className="rateSysCard">
       	<CardHeader className="rateSysCardHeader">
					<h5><span className="fa fa-trophy"></span>&nbsp;&nbsp;ÉTAPE {this.state.sectionsIdx[SI_ELT]} - Trophée Éric Lavoie</h5>
					<p>
						
					</p>
        </CardHeader>
        <CardBody>
					<p>
						Choisir le joueur dans votre ligue qui, selon vous, mérite le trophée du meilleur esprit sportif.
					</p>
					
					<div className="row row-margin-bottom-10">
					<div className="col-md-12">
						{/*<span>Joueur #{cIdx+1}</span>*/}
						<select className="form-control" id="eltSelect"
							value={this.state.selectedELTrophy} onChange={this.handleELTRophyChange}>
							<option value={-1} key={'eltOption.choosePlayer'}>Choisir un joueur</option>
							{this.state.elTrophyList.map(this.dispELTrophyPlayersOptions)}
		      	</select>
					</div>
					</div>

	      </CardBody>
			</Card>
			</div>
			</div>
		)
	}

	// Step 5 - SAUVEGARDE
	dispValidateAndSave() {
		return(
			<div className="row rateSysSectionsMargins">
			<div className="col-12">
      <Card className="rateSysCard">
       	<CardHeader className="rateSysCardHeader">
					<h5><span className="fa fa-save"></span>&nbsp;&nbsp;ÉTAPE {this.state.sectionsIdx[SI_SAV]} - Sauvegarde</h5>
        </CardHeader>
        <CardBody>
					<p>
						Vérifier vos sélections et appuyer sur le bouton suivant pour soumettre votre formulaire.
					</p>
					<div className="row">
					<div className="col-12 text-center">
						<button type="button" className="btn btn-primary" onClick={this.handleSubmitFormClick}>
							Soumettre mon formulaire</button>
						</div>
					</div>
	      </CardBody>
			</Card>
			</div>
			</div>
		)
	}

	displayRespondentSelector() {
    return (
			<div className="col-md-8">
				<span>Personne sondée</span>
				<select className="form-control"
					value={this.state.selectedRespondentIdx} onChange={this.handleRespondentChange}>
					<option value={-1} key={'resp.chooseText'}>Choisir votre nom dans la liste</option>
					{this.state.respondents.map(this.dispRespondentOptions)}
      	</select>
			</div>
    );
	}

	dispRespondentOptions(resp, respIdx, respondents) {
		return (
			<option value={respIdx} key={'resp.'+ respIdx}>{resp.fn} [{resp.ratingStr}] - {resp.team}</option>
		)
	}

	dispOneCommittee(c, cIdx) {
		return (
			<div className="row row-margin-bottom-10" key={"committee." + cIdx}>
				{this.displayCommitteeSelector(cIdx)}
			</div>
		)
	}

	displayCommitteeSelector(cIdx) {
    return (
			<div className="col-md-12">
				<span>Joueur #{cIdx+1}</span>
				<select className="form-control" id={"comSelect." + cIdx}
					value={this.state.selectedCommitteeIdx[cIdx]} onChange={this.handleCommitteeChange}>
					<option value={-1} key={'comOption.choosePlayer'}>Choisir un joueur</option>
					{this.state.committeeList.map(this.dispCommitteePlayersOptions)}
      	</select>
			</div>
    );
	}

	dispCommitteePlayersOptions(spo, spoIdx, sysPlayerOptions) {
		return (
			<option value={spoIdx} key={'comOption.' + spoIdx}>{spo.fn} [{spo.ratingStr}] - {spo.team}</option>
		)
	}

	dispELTrophyPlayersOptions(eltpo, eltpoIdx, eltPlayerOptions) {
		return (
			<option value={eltpoIdx} key={'eltOption.' + eltpoIdx}>{eltpo.fn} [{eltpo.ratingStr}] - {eltpo.team}</option>
		)
	}

	dispPlayersTable() {
		var players = this.state.rateSysPlayers;
		return (
			<div className="row">
			<div className="col-12">

       	<div className="table-responsive tableFixHeader tableFixHeaderRateSys resizeVerticalRateSys">
    		<table className="table table-sm table-ratesysForm forcePointerNoSelect tableFix2col">
	    		<thead><tr>
						{cstTableHeaders.map(this.createTableHdrRow)}
	    		</tr></thead>
	    		<tbody>
	    			{players.length !== 0 ?
	    				players.map(this.dispPlayersTableRow) : 
	    				<tr><td colSpan='99'> Aucun joueur </td></tr>
	    			}
	    		</tbody>
	    	</table>
		    </div>

      </div>
      </div>
		)
	}

	createTableHdrRow(hdrItem, hdrIdx) {
		return (
			<th key={"colid." + hdrIdx}>{hdrItem}</th>
		)
	}

	dispPlayersTableRow(player, idx, players) {
		var classSelectedPlayer = '';
		if (idx === this.state.selectedPlayerIdx) {
			classSelectedPlayer = 'selectedrow';
		}

		return (
  		<tr className={classSelectedPlayer} key={"tr." + idx} id={"tr." + idx} onClick={this.handleSingleClick}>
  			<td>{idx + 1}</td>
  			<td>{player.fn}</td>
  			<td>{player.ratingStr}</td>
  			<td>{player.stats.pj}</td>
  			<td>{player.stats.ips}</td>
  			<td>{player.stats.fp.toFixed(2)}</td>
  			<td>{player.stats.pctWin.toFixed(1)}</td>
  			<td>{player.stats.diff}</td>
  			<td>{player.stats.ep}</td>
  			<td>{player.stats.ec}</td>
  			<td>{player.stats.tvp}</td>
  			<td>{player.team}</td>
  		</tr>
		)
	}

	handleRespondentChange(e) {
		var selectedRespondentIdx = parseInt(e.target.value, 10);
		this.setState({selectedRespondentIdx: selectedRespondentIdx})
		this.loadPlayersAndCommittee(selectedRespondentIdx);
	}

	handleRespondentTelChange(e) {
    this.setState({
    	respondentTel: e.target.value
    });
	}

	handleCommitteeChange(e) {
		var cIdx = e.target.id.split(".")[1];
		var selectedCommitteeIdx = this.state.selectedCommitteeIdx;
		selectedCommitteeIdx[cIdx] = parseInt(e.target.value, 10);
		this.setState({selectedCommitteeIdx: selectedCommitteeIdx});
	}

	handleELTRophyChange(e) {
		this.setState({selectedELTrophy: parseInt(e.target.value, 10)});
	}

	handleSingleClick(e) {
		//e.preventDefault();
		var itemIdx = parseInt(e.currentTarget.id.split('.')[1], 10);
		var selectedPlayerIdx = this.state.selectedPlayerIdx;

		if (selectedPlayerIdx === itemIdx) {
			selectedPlayerIdx = -1;
		} else {
			selectedPlayerIdx = itemIdx;
		}

		this.setState({
			selectedPlayerIdx: selectedPlayerIdx,
		});
	}

	handleArrowClick(dir, e) {
		var rateSysPlayers = this.state.rateSysPlayers;
		var selectedPlayerIdx = this.state.selectedPlayerIdx;

		if (selectedPlayerIdx !== -1) {

			// Validate min/max index
			if ( ((selectedPlayerIdx + dir) >= 0) && 
					 ((selectedPlayerIdx + dir) <= (rateSysPlayers.length - 1) )) {

				// Switch them
				var tempPlayer = rateSysPlayers[selectedPlayerIdx];
				rateSysPlayers[selectedPlayerIdx] = rateSysPlayers[selectedPlayerIdx + dir];
				rateSysPlayers[selectedPlayerIdx + dir] = tempPlayer;

				this.setState({
					rateSysPlayers: rateSysPlayers,
					selectedPlayerIdx: (selectedPlayerIdx + dir)
				});
			}

		} else {
			alert("Vous devez sélectionner un joueur d'abord");
		}

	}

	handleSubmitFormClick() {
		//console.log('SUBMIT');
		var _this = this;
		const findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) !== index)

		var sectionsIdx = this.state.sectionsIdx;

		// Respondent
		var respondents = this.state.respondents;
		var selectedRespondentIdx = this.state.selectedRespondentIdx;
		var selectedELTrophy = this.state.selectedELTrophy;

		// Committee
		var committeeList = this.state.committeeList;
		var elTrophyList = this.state.elTrophyList;
		var selectedCommitteeIdx = this.state.selectedCommitteeIdx;

		var duplicateCommitteeSelections = false;
		var unselectedCommittee = false;
		if (sectionsIdx[2] !== 0) {
			duplicateCommitteeSelections = (findDuplicates(selectedCommitteeIdx).length > 0);
			unselectedCommittee = (selectedCommitteeIdx.filter(cs => (cs === -1)).length > 0);
		}

		var unselectedELTrophy = false;
		if (sectionsIdx[3] !== 0) {
			unselectedELTrophy = (selectedELTrophy === -1);
		}

		// Rankings
		var rankings = [];
		this.state.rateSysPlayers.forEach((rsp, rspIdx) => {
			rankings.push({
				playerId: rsp._id,
				rank: rspIdx + 1
			});
		});

		// VALIDATION
		// Identification
		if (selectedRespondentIdx === -1) {
			alert("Vous devez vous identifier en choisissant votre nom dans la liste.");
		} 
		else if (this.state.respondentTel === "") {
			alert("Vous devez vous entrer votre numéro de téléphone.");
		}
		else if (duplicateCommitteeSelections || unselectedCommittee) {
			alert("Vous devez choisir 5 membres différents pour le comité de cotation.");
		}
		else if (unselectedELTrophy) {
			alert("Vous devez choisir un joueur pour le Trophée Éric Lavoie");
		}
		else {
			var respondent = {
				seasonId: this.props.match.params.seasonid,
				playerId: respondents[selectedRespondentIdx]._id,
				tel: this.state.respondentTel,
				teamDiv: respondents[selectedRespondentIdx].teamDiv,
				ratingScore: 0
			};

			var committee = [];
			selectedCommitteeIdx.forEach(sc => {
				var committeeItemId = "0";
				if (sc !== -1) {
					committeeItemId = committeeList[sc]._id;
				}
				committee.push(committeeItemId)
			});

			var eltrophyPlayerId = "0";
			if (selectedELTrophy !== -1) {
				eltrophyPlayerId = elTrophyList[selectedELTrophy]._id;
			}

			var rateSysFormObj = {
				seasonId: this.props.match.params.seasonid,
				respondent: respondent,
				committee: committee,
				eltrophyPlayerId: eltrophyPlayerId,
				rankings: rankings
			};

			Axios.post('/api/rateSys/saveform/', {
				rateSysFormObj: rateSysFormObj,
			})
			.then(function(response) {
				alert('Votre formulaire a été soumis avec succès, merci pour votre contribution.')
				_this.resetForm();
				window.scrollTo(0, 0);
			})
			.catch(function(error) {
				console.log('error');
				console.log(error);
			});

		}
	}

	// not good for negative values
	isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}


}

export default RateSysForm;



